export default function getBackendUrl() {
  if (window.location.hostname === 'customer.joulepoint.com') {
    return process.env.REACT_APP_BACKEND_ROOT;
  } else if (window.location.hostname === 'customer-test.joulepoint.com') {
    return process.env.REACT_APP_BACKEND_ROOT_TEST;
  } else {
    return process.env.REACT_APP_BACKEND_ROOT_DEV;
  }
}
